import { Box, Group, Text } from '@mantine/core';
import type { ReactElement, ReactNode } from 'react';
import ResponsiveRow from '@/shared/responsive/ResponsiveRow';

interface SettingRowProps {
    title: string;
    description: string;
    leading?: ReactNode;
    control: ReactNode;
    /** Omits the bottom divider on the last row of a section. */
    last?: boolean;
}

/**
 * A labeled settings row — title + description on the left, a control on the
 * right — that stacks to a full-width column on mobile (via {@link ResponsiveRow}).
 */
export default function SettingRow({ title, description, leading, control, last }: SettingRowProps): ReactElement {
    return (
        <ResponsiveRow
            style={{
                paddingTop: 'var(--mantine-spacing-md)',
                paddingBottom: 'var(--mantine-spacing-md)',
                borderBottom: last ? undefined : '1px solid var(--bm-color-border-subtle)',
            }}
        >
            <Group gap="md" wrap="nowrap" style={{ minWidth: 0 }}>
                {leading}
                <Box style={{ minWidth: 0 }}>
                    <Text size="sm" fw={500}>
                        {title}
                    </Text>
                    <Text size="xs" c="dimmed">
                        {description}
                    </Text>
                </Box>
            </Group>
            <Box style={{ flexShrink: 0 }}>{control}</Box>
        </ResponsiveRow>
    );
}
